import api from '../../services/api';

const RECURSO = '/atendimentos/linha-cuidado/tcle/';

class TcleService {
    obter(atendimentoId) {
        return api.get(RECURSO, { params: { atendimento_id: atendimentoId } });
    }

    enviar(atendimentoId, canal) {
        return api.post(`${RECURSO}enviar/`, { atendimento_id: atendimentoId, canal });
    }
}

const tcleService = new TcleService();

export default tcleService;
